import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { environment } from '../../../environments/environment';
import { SettingsPageComponent } from '../pages/settings.component';
import { EditUserPageComponent } from '../pages/edit-user.component';
import { VersionPageComponent } from '../pages/version.component';
import { EditPasswordPageComponent } from '../pages/edit-password.component';
import { TranslationsPageComponent } from '../pages/translations.component';
import { EquipmentsPageComponent } from '../pages/equipments.component';
import { SynchronizationResolver } from '../../utils/syncronization.resolver';
import { CurrentUserResolver } from '../../utils/currentPerson.resolver';
import { PermissionGuard } from '../../utils/permission.guard';

const routes: Routes = [
  {
    path: '',
    resolve: { synchronizeData: SynchronizationResolver },
    children: [
      { path: environment.applicationRoute + '/settings', component: SettingsPageComponent },
      { path: environment.applicationRoute + '/settings/editUser', component: EditUserPageComponent },
      { path: environment.applicationRoute + '/settings/version', component: VersionPageComponent },
      { path: environment.applicationRoute + '/settings/editUser/editPassword', component: EditPasswordPageComponent }
    ]
  },
  {
    path: '',
    resolve: { currentPerson: CurrentUserResolver },
    children: [
      {
        path: environment.applicationRoute + '/settings/translations',
        component: TranslationsPageComponent,
        canActivate: [PermissionGuard],
        data: { permission: 'manage.template' }
      },
      {
        path: environment.applicationRoute + '/settings/equipments',
        component: EquipmentsPageComponent,
        canActivate: [PermissionGuard],
        data: { permission: 'manage.template' }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SettingsRoutingModule {}
